import { useGuaranteedSession } from '@hooks/use-guaranteed-session';
import { useChildEligibilities } from '@react-query/hooks/query/use-child-eligibilities';
import {
    getApplicantParentFnr,
    getApplicantParentName,
    getApproverParentFnr,
    getApproverParentName,
} from '@utils/child-eligibility-utils';

interface UseSessionName {
    data: string | null;
    isPending: boolean;
}

export const useSessionName = (): UseSessionName => {
    const session = useGuaranteedSession();
    const { data: childEligibilities, isPending } = useChildEligibilities();

    if (isPending) {
        return { data: null, isPending: true };
    }

    if (!childEligibilities || childEligibilities.length === 0) {
        return { data: null, isPending: false };
    }

    const sessionFnr = session.fnr.value;

    const matchingEligibility = childEligibilities.find(
        (eligibility) =>
            sessionFnr === getApplicantParentFnr(eligibility) || sessionFnr === getApproverParentFnr(eligibility),
    );

    if (!matchingEligibility) {
        return { data: null, isPending: false };
    }

    const userIsApplicant = sessionFnr === getApplicantParentFnr(matchingEligibility);

    const sessionName = userIsApplicant
        ? getApplicantParentName(matchingEligibility)
        : getApproverParentName(matchingEligibility);

    return { data: sessionName, isPending: false };
};
